
import InteractionButtons from "./addInteractions";
import { ReminderElipses,InteractionCallIcon,InteractionEmailIcon,InteractionEventIcon,InteractionSocMedIcon,InteractionTextIcon } from "../../../lead-inventory/icons";
const InteractionsSidebarCard = ({
    interactions,
    leadId, 
    page, 
    pageSize,
    interactionsCount,
    totalPages,
    setPage
}) => {


    return (
        <div className='flex flex-col gap-4 scrollbar-hide'>
            <div className="flex flex-col justify-between gap-2 border border-[#64748B] rounded-lg p-4 bg-white ">
                <div className="flex flex-row gap-2 justify-between overflow-auto">
                    <h1 className="font-bold text-xl py-1">Interactions</h1>
                    <InteractionButtons leadId = {leadId}/>
                </div>
                {interactions.length > 0 ? (
                    interactions.map((item, index) => (
                        <div className="flex flex-row gap-2 items-start border-b border-[#E2E8F0] hover:bg-[#F1F5F9] p-2 overflow-x-auto" key={index}>
                            <a>
                                {item.contact_method.includes("Call") && <img src={InteractionCallIcon} alt="Call" className="w-6 h-6 inline-block gap-3 item-center" />}
                                {item.contact_method.includes("mail") && <img src={InteractionEmailIcon} alt="Email" className="w-6 h-6 inline-block gap-3 item-center" />}
                                {item.contact_method.includes("Event") && <img src={InteractionEventIcon} alt="Event" className="w-6 h-6 inline-block gap-3 item-center" />}
                                {item.contact_method.includes("Social Media") && <img src={InteractionSocMedIcon} alt="Social Media" className="w-6 h-6 inline-block gap-3 item-center" />}
                                {item.contact_method.includes("Text/Message") && <img src={InteractionTextIcon} alt="Text" className="w-6 h-6 inline-block gap-3 item-center" />}
                            </a>
                            <div className="flex flex-col w-[90%]">
                                <div>
                                    <a className="text-sm text-[#475569]">{item.date_of_interaction}</a>
                                </div>
                                <div className="flex flex-row gap-2 item-center text-[#1E293B]"> 
                                    <a className="gap-4 item-center font-bold"
                                    >
                                        {item.contact_method}
                                    </a>
                                    <a>
                                        <img src={ReminderElipses} alt="Seperator" className="w-2 h-2 inline-block gap-3 item-center" /> 
                                    </a>
                                    <a className="font-bold">
                                        {item?.purpose || 'No Title'} 
                                    </a>                            
                                </div>
                                <a className="overflow-hidden text-ellipsis whitespace-nowrap text-[#475569]"
                                    >
                                    {item.notes}
                                    </a>
                            </div>
                        </div>
                    ))
                ):(
                    <div>
                        <a>No Data Available</a>
                    </div>
                )}
                <div className="flex flex-row justify-between items-center p-2">
                    <span className="text-sm text-[#94A3B8]">
                        Showing {((page - 1) * pageSize) + 1} to {Math.min(page * pageSize, interactionsCount)} of {interactionsCount} entries
                    </span>
                    {/* Pagination */}
                    <div className='px-2 gap-2 flex'>
                        <button
                            onClick={() => setPage(page - 1)}
                            disabled={page === 1}
                            enabed={page === totalPages}
                            hidden={page === 1}
                            className={`border border-[#1E293B] py-2 px-4 rounded-full ${page === 1 ? 'bg-[#1E293B] text-white cursor-not-allowed' : ''}`}
                        >
                            {page - 1 > 0 ? page - 1 : page}
                        </button>
                        <button
                            onClick={() => setPage(page)}
                            disabled={page === totalPages}
                            className={`${page === page ? 'bg-[#1E293B] text-white' : 'bg-white text-[#1E293B]'} border border-[#1E293B] py-2 px-4 rounded-full ${page === totalPages ? ' cursor-not-allowed' : 'hover:bg-gray-200'}`}
                        >
                            {page}
                        </button>
                        {page < totalPages && (
                            <button
                                onClick={() => setPage(page + 1)}
                                className="bg-white text-[#1E293B] border border-[#1E293B] py-2 px-4 rounded-full hover:bg-gray-200"
                            >
                                {page + 1}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InteractionsSidebarCard;